<template>
    <component
        :is="to ? 'nuxt-link' : href ? 'a' : 'div'"
        class="base-lined-card"
        v-bind="to ? {
            to,
        } : href ? {
            href,
            target: '_blank',
            rel: 'noopener',
        } : {}"
    >
        <div class="media">
            <div
                v-if="$slots['media-header']"
                class="media-header"
                v-test:mediaHeader
            >
                <slot name="media-header" />
            </div>
            <div class="image-holder">
                <lazy-image
                    :src="image.src || notAvailableImage"
                    :alt="image.alt || ''"
                    :width="image.width"
                    :height="image.height"
                />
            </div>
        </div>
        <div class="textual-content">
            <strong class="title" v-test:title>{{ title }}</strong>
            <slot />
        </div>
    </component>
</template>

<script>
    import notAvailableImage from '../../../assets/images/not-available.png';

    export default {
        name: 'base-lined-card',

        props: {
            image: {
                type: Object,
                required: true,
            },

            title: {
                type: String,
                required: true,
            },

            href: {
                type: String,
                default: '',
            },

            to: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                notAvailableImage,
            };
        },
    };
</script>

<style lang="scss" scoped>
    .base-lined-card {
        &:hover,
        &:focus-within,
        &:active {
            text-decoration: none;
        }
    }

    .media {
        margin-bottom: 16px;
        height: 200px;
        overflow: hidden;
    }

    .image-holder {
        transition: filter 0.3s;
        display: flex;
        justify-content: center;
        align-content: center;
        height: 100%;
    }

    .lazy-image {
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
    }

    .textual-content {
        text-align: center;
        color: primary-palette(2);
    }

    .title {
        display: block;
        font-weight: bold;
    }
</style>
